module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/izabela-sawa-88038668242f907298d0e5a9aea82307.png";